export { default } from 'features/support/routes/support-route';
